import { Actor } from "./actor.js";
import { wasmFuncs } from "./module.js";
import { Struct, getStringAt, getWasmReader } from "./struct.js";
const tileTypeNames = {};
export class TileType extends Struct {
    get name() {
        if (this._ptr in tileTypeNames)
            return tileTypeNames[this._ptr];
        const str = getStringAt(this.getPtr(0));
        tileTypeNames[this._ptr] = str;
        return str;
    }
    get itemIndex() {
        return wasmFuncs.TileType_get_item_index(this._ptr);
    }
}
export class BasicTile extends Struct {
    get type() {
        return new TileType(wasmFuncs.BasicTile_get_type(this._ptr));
    }
    get customData() {
        return wasmFuncs.BasicTile_get_custom_data(this._ptr);
    }
    getCell() {
        // FIXME: AAA
        return new Cell(wasmFuncs.BasicTile_get_cell(this._ptr, 4));
    }
}
export var Layer;
(function (Layer) {
    Layer[Layer["SPECIAL"] = 0] = "SPECIAL";
    Layer[Layer["ACTOR"] = 1] = "ACTOR";
    Layer[Layer["ITEM_MOD"] = 2] = "ITEM_MOD";
    Layer[Layer["ITEM"] = 3] = "ITEM";
    Layer[Layer["TERRAIN"] = 4] = "TERRAIN";
})(Layer || (Layer = {}));
export class Cell extends Struct {
    get special() {
        const ptr = wasmFuncs.Cell_get_layer(this._ptr, Layer.SPECIAL);
        if (getWasmReader().getUint32(ptr) === 0)
            return null;
        return new BasicTile(ptr);
    }
    get actor() {
        const ptr = wasmFuncs.Cell_get_actor(this._ptr);
        if (ptr === 0)
            return null;
        return new Actor(ptr);
    }
    get itemMod() {
        const ptr = wasmFuncs.Cell_get_layer(this._ptr, Layer.ITEM_MOD);
        if (getWasmReader().getUint32(ptr) === 0)
            return null;
        return new BasicTile(ptr);
    }
    get item() {
        const ptr = wasmFuncs.Cell_get_layer(this._ptr, Layer.ITEM);
        if (getWasmReader().getUint32(ptr) === 0)
            return null;
        return new BasicTile(ptr);
    }
    get terrain() {
        const ptr = wasmFuncs.Cell_get_layer(this._ptr, Layer.TERRAIN);
        if (getWasmReader().getUint32(ptr) === 0)
            return null;
        return new BasicTile(ptr);
    }
    get poweredWires() {
        return wasmFuncs.Cell_get_powered_wires(this._ptr);
    }
    get isWired() {
        return !!wasmFuncs.Cell_get_is_wired(this._ptr);
    }
}
//# sourceMappingURL=cell.js.map